import { segmentAudioSignature } from './segmentAudioIdentity.ts';
import type { RoleRow } from './types.ts';
type FragmentProject = { roles?: RoleRow[]; pronunciations?: Array<{ source: string; replacement: string; enabled?: boolean }> };
import type { RenderFragment, RenderInfo } from './api';
import type { SegmentRow } from './types';

// Match the renderer's edge-whitespace normalization while keeping internal text exact.
export function findMatchingFragment(fragments: RenderFragment[] | undefined, segment: SegmentRow, project?: FragmentProject): RenderFragment | undefined {
  return matchingFragmentIndex(fragments, [segment], project).get(segment[0]);
}

export function matchingFragmentIndex(fragments: RenderFragment[] | undefined, segments: SegmentRow[], project?: FragmentProject): Map<number, RenderFragment> {
  const groups = new Map<string, RenderFragment[]>();
  for (const fragment of fragments ?? []) {
    const key = project && fragment.generationSignature ? fragment.generationSignature : JSON.stringify([fragment.sourceText.trim(), fragment.synthesisText.trim()]);
    const group = groups.get(key) ?? [];
    group.push(fragment); groups.set(key, group);
  }
  const index = new Map<number, RenderFragment>();
  for (const segment of segments) {
    const signature = project ? segmentAudioSignature(project, segment) : '';
    const matches = groups.get(signature) ?? groups.get(JSON.stringify([String(segment[5]).trim(), String(segment[6]).trim()]));
    const valid = matches?.filter(fragment => !fragment.generationSignature || !project || fragment.generationSignature === signature);
    const match = valid?.find(fragment => fragment.order === segment[0]) ?? valid?.[0];
    if (match) index.set(segment[0], match);
  }
  return index;
}

export function mergeSegmentFragment(render: RenderInfo, fragment: RenderFragment): RenderInfo {
  const fragments = render.fragments ?? [];
  const found = fragments.some(item => item.order === fragment.order);
  return { ...render, fragments: found
    ? fragments.map(item => item.order === fragment.order ? fragment : item)
    : [...fragments, fragment].sort((left, right) => left.order - right.order) };
}

export function countMatchingFragments(fragments: RenderFragment[] | undefined, segments: SegmentRow[]): number {
  return matchingFragmentIndex(fragments, segments).size;
}

export function filterSegmentsWithoutMatchingFragments(fragments: RenderFragment[] | undefined, segments: SegmentRow[]): SegmentRow[] {
  const index = matchingFragmentIndex(fragments, segments);
  return segments.filter(segment => !index.has(segment[0]));
}
